import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DevicesState {
  devices: any | null;
  sdCardInsertStatus?: boolean;
}

const initialState: DevicesState = {
  devices: null,
  sdCardInsertStatus: false,
};

const DevicesStatusSlice = createSlice({
  name: "DevicesStatus",
  initialState,
  reducers: {
    setDevices: (state: any, action: PayloadAction<any | null>) => {
      state.devices = action.payload;
    },
    setSdCardInsertStatus: (state: any, action: PayloadAction<boolean>) => {
      state.sdCardInsertStatus = action.payload;
    },
  },
});

export const { setDevices, setSdCardInsertStatus } = DevicesStatusSlice.actions;
export default DevicesStatusSlice.reducer;
